<template>
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="error-modal">
              <div class="close-modal">
                <i class="fas fa-times" @click="close"></i>
              </div>
            <div class="error-container">
              <div class="error-title">Purchase Failed</div>
              <div v-if="errorPresent">
                <span v-if="errorMessage && errorMessage !== ''" class="error-message">
                  {{errorMessage}}
                </span>
                <span v-if="!errorMessage || errorMessage === ''" class="error-message">
                  Error: {{ $t('clearCache') }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
</template>

<script>
export default {
  name: "errorModal",
  props: ['errorPresent', 'errorMessage', 'close']
}
</script>

<style lang="less">
@import "../../assets/css/errorModal.less";
</style>



// WEBPACK FOOTER //
// src/view/Modal/errorModal.vue